export class CompletionNumberType {
    ID: number;
    Name: string;
    
}

export default CompletionNumberType;